export default "__VITE_ASSET__T95bbzDK__"